import moment from 'moment'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'

import {
  selectCurrentGroupId,
  selectCurrentHotelId,
  selectIncomingEmails,
  selectInviteEmails,
  selectInvoiceEmails,
  selectLoginEmails
} from '../../accessors'
import CustomHeader from '../../components/ReusableComponents/HeaderTitles'
import LoadingIndicator from '../../components/ReusableComponents/LoadingIndicator'
import SearchTextInput from '../../components/ReusableComponents/SearchTextInput'
import SmartDatepicker from '../../components/ReusableComponents/SmartDatepicker'
import Table from '../../components/ReusableComponents/Table'
import Tab from '../../components/ReusableComponents/Tabs'
import styles from './EmailLogs.module.scss'
import { fetchEmailLogs } from './EmailLogsSlice'
import EmailViewerDialog from './EmailViewerDialog'
import EmailRow from './Row'
import TitleRow from './TitleRow'

const EmailLogs = () => {
  const dispatch = useDispatch()

  const currentSubsidiaryId = useSelector(selectCurrentHotelId)
  const currentGroupId = useSelector(selectCurrentGroupId)
  const invoiceEmails = useSelector(selectInvoiceEmails)
  const loginEmails = useSelector(selectLoginEmails)
  const inviteEmails = useSelector(selectInviteEmails)
  const incomingEmails = useSelector(selectIncomingEmails)
  const isLoading = useSelector(s => s.emailLogs.isLoading)
  const isErred = useSelector(s => s.emailLogs.isErred)

  const { type } = useParams()

  const dataByType = {
    invoice: invoiceEmails,
    login: loginEmails,
    invite: inviteEmails,
    incoming: incomingEmails
  }

  const [emailViewId, setEmailViewId] = useState()
  const [searchQuery, setSearchQuery] = useState('')
  const [startDate, setStartDate] = useState(moment().add(-1, 'month'))
  const [endDate, setEndDate] = useState(moment())

  function filterResults(results) {
    return results.filter(r => r.searchString.match(new RegExp(searchQuery, 'gi')))
  }

  useEffect(() => {
    dispatch(
      fetchEmailLogs({
        merchantId: currentGroupId,
        subsidiaryId: currentSubsidiaryId,
        fromDate: startDate.format('YYYY-MM-DD'),
        toDate: endDate.format('YYYY-MM-DD')
      })
    )
  }, [currentGroupId, currentSubsidiaryId, dispatch, endDate, startDate])

  return (
    <div className={styles.wrapper}>
      <CustomHeader title="Email logs" width={1180} isFixed />
      {emailViewId && (
        <EmailViewerDialog
          emailId={emailViewId}
          handleClose={() => setEmailViewId(null)}
        />
      )}
      {isErred && <div>Something went wrong while getting emails.</div>}
      {isLoading && <LoadingIndicator marginTop={200} />}
      {!isLoading && !isErred && (
        <>
          <Tab.Parent>
            <Tab to="/emails/invoice">Invoice ({invoiceEmails.length})</Tab>
            <Tab disabled={loginEmails.length === 0} to="/emails/login">
              Login ({loginEmails?.length})
            </Tab>
            <Tab disabled={inviteEmails.length === 0} to="/emails/invite">
              Invite ({inviteEmails.length})
            </Tab>
            <Tab disabled={incomingEmails.length === 0} to="/emails/incoming">
              Incoming ({incomingEmails.length})
            </Tab>
          </Tab.Parent>
          <div className={styles.filters}>
            <SearchTextInput handleChange={v => setSearchQuery(v)} />
            <SmartDatepicker
              startDate={startDate}
              endDate={endDate}
              onChangeStartDate={d => setStartDate(d)}
              onChangeEndDate={d => setEndDate(d)}
            />
          </div>
          <div className={styles.tableContainer}>
            <Table widths={[280, 200, 400, 224, 30]}>
              <TitleRow />
              {filterResults(dataByType[type]).map(m => (
                <EmailRow {...m} key={m.id} handleSetViewId={setEmailViewId} />
              ))}
              {filterResults(dataByType[type]).length === 0 && (
                <div className={styles.noResults}>
                  <p>No emails found. Try modifying filters.</p>
                </div>
              )}
            </Table>
          </div>
        </>
      )}
    </div>
  )
}

export default EmailLogs
